'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNKNOWN_CLIENT = exports.UNKNOWN_CLIENT = 'unknown_client';

var DASHBOARD_WEB = exports.DASHBOARD_WEB = 'dashboard_web';

var MOBILE_STORE = exports.MOBILE_STORE = 'mobile_store';

var NATIVE_APP = exports.NATIVE_APP = 'native_app';

var WIDGET = exports.WIDGET = 'widget';

var PWA = exports.PWA = 'pwa';


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/constants/client.js
// module id = 429
// module chunks = 0